export default {"src":"/_next/static/media/commissions-left-arrow-icon.fc380762.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};